import { Validators, ValidatorFn, AbstractControl } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}


export const PERIODEVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
        ['id', new FormInfo(true, [])],
        ['idSociete', new FormInfo(true, [])],
        ['statut', new FormInfo(true, [])],
        ['annee', new FormInfo(true, [])],
        ['mois', new FormInfo(true, [])],
        ['date', new FormInfo(false, [])],

    ]),
    EDIT: new Map<string, FormInfo>([
        ['id', new FormInfo(true, [])],
        ['idSociete', new FormInfo(true, [])],
        ['statut', new FormInfo(true, [])],
        ['annee', new FormInfo(true, [])],
        ['mois', new FormInfo(true, [])],
        ['date', new FormInfo(false, [])],
     
    ]),
    VISUALIZE: new Map<string, FormInfo>([
        ['id', new FormInfo(false, [])],
        ['idSociete', new FormInfo(false, [])],
        ['statut', new FormInfo(true, [])],
        ['annee', new FormInfo(true, [])],
        ['mois', new FormInfo(true, [])],
        ['date', new FormInfo(false, [])],
    ])
  };
